enum AccessReportsWizardStepEnum {
  CoverPage = "Cover Page",
  AccessAnalysis = "Access Analysis",
  Population = "Population",
  PageOptions = "Page Options",
  Review = "Review",
  PrintOptions = "Print Options",
  MultiElementOptions = "Multi Element Option",
}

export { AccessReportsWizardStepEnum };
